import React from 'react'
import milkIcon from './icons/milk.png'

interface MilkCupProps {
	width?: number | string
	height?: number | string
	color?: string
	onClick?: () => void
	style?: React.CSSProperties
}

const MilkCup: React.FC<MilkCupProps> = ({
	width = 16,
	height = 16,
	color = '#7F7F84',
	onClick,
	style,
}) => (
	<span
		onClick={onClick}
		style={{
			width,
			height,
			display: 'inline-block',
			flexShrink: 0,
			backgroundColor: color,
			maskImage: `url(${milkIcon})`,
			WebkitMaskImage: `url(${milkIcon})`,
			maskSize: 'contain',
			WebkitMaskSize: 'contain',
			maskRepeat: 'no-repeat',
			WebkitMaskRepeat: 'no-repeat',
			maskPosition: 'center',
			WebkitMaskPosition: 'center',
			cursor: onClick ? 'pointer' : 'default',
			...style,
		}}
	/>
)

export default MilkCup
